import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../css/Usuarios.css";
import Menu from "./components/Menu";
import { dB64 } from "../shared/Encriptacion";
import axios from "axios";
import { HEADERS_API } from "./NuevaGuia";
import { ValidarSesion } from "../shared/Validaciones";
import { ListaUnidadesMedida } from "../shared/UnidadesMedida";
import Paginador from "./components/Paginador";
import { NMTipoDireccion } from "../shared/Denominaciones";

export default function Direcciones(){
    // ======================================================================================================
    //#region HOOKS STATE
    // ======================================================================================================

    // ESTADOS DE CONTENIDO
    const[listaDirecciones, setListaDirecciones] = useState(<></>);

    // ESTADOS DE FILTRO
    const[filtroTipo, setFiltroTipo] = useState("");
    //#endregion

    // ESTADOS DE PAGINACIÓN
    const[paginador, setPaginador] = useState(<></>);

    // ======================================================================================================
    //#region HOOKS EFFECT
    // ======================================================================================================
    useEffect(()=>{
        ValidarSesion();
        ObtenerListaDirecciones(filtroTipo, 1);
    },[]);

    //#endregion

    // ======================================================================================================
    //#region HANDLERS
    // ======================================================================================================
    // ESTADOS DE CONTENIDO
    const HandlerListaDirecciones = (valor) => setListaDirecciones(valor);

    // ESTADOS DE FILTRO
    const HandlerFiltroTipo = (valor) => setFiltroTipo(valor);
 
    // ESTADOS DE PAGINACIÓN
    const HandlerPaginador = (valor) => setPaginador(valor);

    //#endregion

    // ======================================================================================================
    //#region FUNCIONES
    // ======================================================================================================
    // FUNCIONES ASÍNCRONAS
    
    const ObtenerListaDirecciones = async(tipo, pagina) => {
        try{
            const response = await axios.get(URL_LISTAR_DIRECCIONES,{
                headers: HEADERS_API,
                params: {
                    tipoDireccion: tipo,
                    pagina: pagina
                }
            }).catch(error => {
                throw new Error(error.message);
            });
            HandlerListaDirecciones(response.data.lista);
            if(response.data.lista.length > 0){
                const total = response.data.lista[0].total;
                const regPag = response.data.lista[0].regPag;
                const pag = response.data.lista[0].pagina;
                HandlerPaginador(<Paginador totalRegistros={total} regPag={regPag} pagina={pag} funcion={FuncionPaginador}/>);
            }else{
                HandlerPaginador(<></>);
            }
        }catch(error){
            console.log(error);
        }
    }

    // FUNCIONES COMPLEMENTARIAS
    const QuitarFiltros = () => {
        HandlerFiltroTipo("")
        ObtenerListaDirecciones("",1);
    }

    // FUNCIÓN PAGINADOR
    const FuncionPaginador = (pagina) =>{
        ObtenerListaDirecciones(filtroTipo, pagina);
    }
    //#endregion

    // ======================================================================================================
    //#region CONTENIDO
    // ======================================================================================================
    return(<>
    <Menu/>
    <div className="container">
        <div className="row">
            <div className="col-12 py-2 border-bottom border-secondary text-secondary text-center text-md-start">
                <h2>{dB64(localStorage.getItem('r6'))}</h2>
            </div>
            <div className="col-12 py-3 text-center">
                <h2>DIRECCIONES FRECUENTES</h2>
            </div>
            <div className="col-12 py-1">
                <Link to={"/nueva-direccion"}>
                    <button className="btn btn-primary">Nueva Dirección</button>
                </Link>
            </div>
            {/* FILTROS */}
            <div className="col-12 col-md-9 p-1">
                <div className="form-floating">
                    <select onChange={e=>HandlerFiltroTipo(e.target.value)} value={filtroTipo} id="tipo-direccion" 
                    className="form-select" placeholder="Tipo de dirección">
                        <option value="">Seleccionar</option>
                        <option value="anexo">Establecimiento anexo</option>
                        <option value="frecuente">Dirección frecuente</option>
                    </select>
                    <label htmlFor="tipo-direccion">Tipo de dirección</label>
                </div>
            </div>
            <div className="col-12 col-md-3">
                <button onClick={e=>ObtenerListaDirecciones(filtroTipo, 1)} className="btn btn-primary my-1 w-100">Filtrar</button>
                <button onClick={QuitarFiltros} className="btn btn-secondary w-100">Quitar filtros</button>
            </div>
            {/* TABLA */}
            <div className="contenedor-tabla py-4">
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>Tipo</th>
                            <th>Dirección</th>
                            <th>Ubigeo</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            listaDirecciones.length > 0 ? listaDirecciones.map((item, index) => (
                                <tr key={index}>
                                    <td >{NMTipoDireccion(item.tipo)}</td>
                                    <td>{item.direccion}</td>
                                    <td>{item.ubigeo}</td>
                                    <td>
                                        <Link to={`/detalle-direccion/${item.codigo}`} className="btn btn-primary">
                                        Detalles
                                        </Link>
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan={5} className="text-secondary text-center fs-4 fw-semibold">Sin resultados</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
            <div className="d-flex justify-content-center">
                {paginador}
            </div>
        </div>
    </div>
    </>)

    //#endregion
}

// ======================================================================================================
//#region CONSTANTES
// ======================================================================================================
const URL_LISTAR_DIRECCIONES = process.env.REACT_APP_URL_LISTAR_DIRECCIONES
//#endregion